var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailLightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.92784 13.2598L13.2614 19.5069C14.0934 20.0616 14.5095 20.3389 14.9592 20.4467C15.3564 20.5419 15.7707 20.5419 16.1681 20.4467C16.6178 20.3389 17.0339 20.0616 17.8659 19.5069L27.1995 13.2598M13.3567 5.56701L5.8342 10.2913C5.12483 10.7368 4.77015 10.9595 4.51289 11.2606C4.28521 11.5271 4.11389 11.837 4.00928 12.1716C3.89111 12.5496 3.89111 12.9684 3.89111 13.8061V22.0794C3.89111 23.5321 3.89111 24.2586 4.17385 24.8134C4.42253 25.3015 4.81936 25.6984 5.30746 25.947C5.86234 26.2298 6.58873 26.2298 8.04151 26.2298H23.0867C24.5395 26.2298 25.2659 26.2298 25.8208 25.947C26.3088 25.6984 26.7057 25.3015 26.9543 24.8134C27.2371 24.2586 27.2371 23.5321 27.2371 22.0794V13.8061C27.2371 12.9684 27.2371 12.5496 27.1189 12.1716C27.0143 11.837 26.8431 11.5271 26.6153 11.2606C26.3581 10.9595 26.0034 10.7368 25.294 10.2913L17.7715 5.56701C16.9708 5.06425 16.5706 4.81288 16.1411 4.71489C15.7612 4.62824 15.367 4.62824 14.9871 4.71489C14.5576 4.81288 14.1574 5.06425 13.3567 5.56701Z",
    stroke: "#F0F6FE",
    strokeWidth: 2.594,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailLightIcon);
export default __webpack_public_path__ + "static/media/emailLightIcon.ec7be07e3eb36e540ec054d6161e4324.svg";
export { ForwardRef as ReactComponent };